/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials200,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParamsSchema =
  z
    .object({
      companyId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse>;
